import axiosInstance from '../helpers/axiosInstance'

// The romaneios (carrier handover documents) of a warehouse, open and handed over, with their PDFs
// (platform ShippingDispatchesController#romaneios). Filters: number (prefix), carrier, status
// (open / handed_over), from / to (the warehouse-local day it was opened), order_number.
export const fetchRomaneios = async (warehouseId, params) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/shipping-dispatch/romaneios`, { params })
  return res.data
}
